import { BookingCalendarEventDetailInternalResponse } from 'api';
import { WisoryLabel } from 'components/Inputs';
import dayjs from 'dayjs';
import { t } from 'i18next';

export const TimeSlotSection = ({ slot }: { slot: BookingCalendarEventDetailInternalResponse }) => {
  const currentLocale = WISORY_SDK_SETTINGS.LOCALE || 'sv';

  const displayText = () => {
    const dateFormat = dayjs(slot.startTime).format('D MMMM YYYY');
    const startTimeFormat = dayjs(slot.startTime).format('HH:mm');
    const endTimeFormat = dayjs(slot.endTime).format('HH:mm');

    if (currentLocale === 'sv') {
      return `${dateFormat}, ${dayjs(slot.startTime).format('[kl]')} ${startTimeFormat}-${endTimeFormat}`;
    }

    return `${dateFormat}, ${startTimeFormat}-${endTimeFormat} ${dayjs(slot.startTime).format('A')}`;
  };

  return (
    <div className="flex mb-5 sm:flex-row flex-col text-black">
      <WisoryLabel className="sm:w-44 mr-3 sm:mb-0 mb-3">{t('REACT_BOOKING_FRONTEND.common.dateAndTime')}</WisoryLabel>
      <div className="sm:w-4/5 flex flex-col font-openSans">{displayText()}</div>
    </div>
  );
};
